<template>
  <v-container id="director-bulletin" pt-0 pb-3 px-3>
    <v-container id="bulletin-container" pa-0>
      <v-flex fill-height align-center d-flex>
        <v-img
          :src="step.dialogUrls[currentDialogIndex].url"
          contain
          max-height="100%"
          max-width="100%"
        ></v-img>
      </v-flex>
    </v-container>
    <img id="director-figure" :src="directorFigure" height="140px">
  </v-container>
</template>

<script>
import directorFigure from "@/assets/directorBulletin/directorFigure.png";

export default {
  name: "director-bulletin",
  props: {
    step: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentDialogIndex: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      directorFigure,
      numOfDialogViews: this.step.dialogUrls.length
    };
  },
  methods: {
    goBack() {
      this.$store.dispatch("decrementStep");
    },
    goForward() {
      this.$store.dispatch("incrementStep");
    },
    swipe(direction) {
      console.log("swiping-2", direction, this.numOfDialogViews);
      switch (direction) {
        case "right":
          if (this.currentDialogIndex === 0) {
            this.goBack();
          } else {
            this.currentDialogIndex -= 1;
          }
          break;
        case "left":
          if (this.currentDialogIndex + 1 === this.numOfDialogViews) {
            this.goForward();
          } else {
            this.currentDialogIndex += 1;
          }
          break;
      }
    }
  }
};
</script>

<style scoped>
#director-bulletin {
  position: absolute;
  top: 110px;
  bottom: 0px;
}

#bulletin-container {
  height: 90%;
}

#director-figure {
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
